import {
  IconBell,
  IconBinocularsGray,
  IconChainLink,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import mainVideo from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/constructionSop/img/1.avif';
import image2 from '@src/assets/images/solution/constructionSop/img/2.avif';
import image3 from '@src/assets/images/solution/constructionSop/img/3.avif';
import image4 from '@src/assets/images/solution/constructionSop/img/4.avif';
import image5 from '@src/assets/images/solution/constructionSop/img/5.avif';
import image6 from '@src/assets/images/solution/constructionSop/img/6.avif';
import image7 from '@src/assets/images/solution/constructionSop/img/7.avif';
import image8 from '@src/assets/images/solution/constructionSop/img/8.avif';

export default {
  type: '建筑解决方案',

  banner: {
    title: '危险自动检测与应对',
    desc: '根据SOP实时检测现场危险情况并自动响应，所有记录均以数据形式保存，可作为审计和报告的证据资料。通过数字化技术提高安全管理效率，防止事故发生。',
  },

  video: {
    title: '基于标准化流程自动检测事故并快速应对',
    desc: '实时检测作业人员的动线和危险因素，并基于SOP自动联动报警、记录、应对，实现系统化安全措施。数据自动保存，便于后期分析和审计。',
    play: mainVideo,
  },

  func: [
    {
      theme: '危险自动检测及实时应对',
      title: '基于SOP的自动危险识别',
      desc: '分析作业人员的动作和周围环境，自动检测不符合SOP的作业，并基于AI判断异常征兆。',
      sub1: '提供高精度',
      icon1: IconRulerGray,
      sub2: '实时状态把握',
      icon2: IconClockGray,
      image: image1,
    },
    {
      title: '危险检测时自动调用SOP应对面板',
      desc: '当发生危险事件时，会自动弹出与作业类型相符的SOP应对步骤。应对者只需一键即可立即开始操作，有助于把握黄金时间。',
      sub1: '快速数据联动',
      icon1: IconTvocGray,
      sub2: '实时位置追踪',
      icon2: IconBinocularsGray,
      image: image2,
    },
    {
      title: '自动保存CCTV查看及浏览记录',
      desc: '自动调用危险发生区域的CCTV，所有查看过的视频和时间均自动记录，可直接用于后期事故调查或法律证据。',
      sub1: '实时位置追踪',
      icon1: IconBinocularsGray,
      sub2: '提供高精度',
      icon2: IconRulerGray,
      image: image3,
    },
    {
      title: '支持移动端参与SOP应对',
      desc: '即使没有电脑，也可通过手机参与SOP流程，外部管理人员或在途负责人也能实时应对，紧急情况下不受空间限制继续处理。',
      sub1: '自由范围设置',
      icon1: IconZoneGray,
      sub2: '多区域设置',
      icon2: IconTagGray,
      image: image4,
    },
    {
      theme: 'SOP运营及定制化管理',
      title: 'SOP应对现状可视化',
      desc: '根据进行中的SOP场景，仪表盘上显示当前阶段和完成状态，一目了然掌握整体应对进度。管理员可根据优先级分配额外人力或资源。',
      sub1: '自由范围设置',
      icon1: IconTagGray,
      sub2: '多区域设置',
      icon2: IconZoneGray,
      image: image5,
    },
    {
      title: '自动生成报告并下载',
      desc: '基于应对记录、报警发生时间、应对完成情况等主要数据自动生成报告，可导出为PDF或Excel格式，节省每周/月报告所需时间和人力。',
      sub1: '提供高精度',
      icon1: IconZoneGray,
      sub2: '多区域设置',
      icon2: IconTagGray,
      image: image6,
    },
    {
      title: '基于条件生成报警场景',
      desc: '可组合温度、气体、位置、动作状态等条件，生成自定义报警规则，从而设置与多种IoT传感器联动的自动危险检测触发器。',
      sub1: '快速安装完成',
      icon1: IconTagGray,
      sub2: '多区域设置',
      icon2: IconTagGray,
      image: image7,
    },
    {
      title: '编辑SOP场景并根据现场定制',
      desc: '可根据现场特点和作业类型编辑或新建SOP步骤。通过GUI界面，任何人都可以轻松添加、删除步骤并应用到现场。',
      sub1: '实时可视化',
      icon1: IconShareGray,
      sub2: '多区域设置',
      icon2: IconTagGray,
      image: image8,
    },
  ],

  subfunc: {
    title: '多样化功能',
    desc: '保障作业人员安全可提高效率并减少因事故造成的损失。ORBRO为保护建筑现场作业人员，配置了最优化功能。当作业人员靠近危险区域或发生事故，以及包括重型设备潜在危险在内的各类安全事故，都能通过系统及时应对。',
    data: [
      { icon: IconWarning, title: '实时风险检测', desc: '人员传感器即刻检测并通知。' },
      { icon: IconBell, title: 'SOP自动执行', desc: '触发风险时自动弹出SOP。' },
      { icon: IconDashboard, title: '综合监控', desc: '一目了然查看安全数据。' },
      { icon: IconBell, title: '异常自动通知', desc: '自动短信、邮件提醒用户。' },
      { icon: IconRoute, title: 'CCTV自动联动', desc: '事件发生自动调用视频。' },
      { icon: IconSearch, title: '手机应急处理', desc: '手机也可执行SOP操作。' },
      { icon: IconChartRadius, title: '进度实时显示', desc: '实时查看SOP进度状态。' },
      { icon: IconChainLink, title: '风险条件设定', desc: '可自定义传感器条件。' },
      { icon: IconChartRadius, title: '自动报告生成', desc: '按历史自动生成PDF等。' },
      { icon: IconSecurity, title: '审计法律证据', desc: '所有记录自动保存审计用。' },
    ],
  },

  system: {
    title: '系统构成',
    img: rtlsSystem,
  },

  productTitle: '产品构成',
  product: [{ tag: 'workerPackage' }, { tag: 'assetPackage' }],

  contents: [{ data: 'constructionAsset' }, { data: 'constructionEquipment' }, { data: 'blogRTLS' }, { data: 'blogMedical' }],
};
